import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { AccountTypeEnum } from "../../../../graphql/supergraphTypes";
import { instructionsStyle, listStyle } from "../styles_vanilla.css";
import { getRefreshInstructions } from "../utils";

export const Instructions = ({
  variant,
  orgName,
  accountType,
  className,
}: {
  variant: "dark" | "light";
  orgName: string;
  accountType?: AccountTypeEnum | null;
  className?: string;
}) => {
  const instructions = getRefreshInstructions(accountType);
  return (
    <Flex flexDirection="column" gap={Sizes.XS} alignItems="flex-start" className={className}>
      <Text variant="regular-md" className={instructionsStyle[variant]}>
        Relevant changes can include updates to {orgName}&apos;s:
      </Text>
      <Flex flexDirection="column" gap="4px" className={listStyle}>
        {instructions.map((instruction) => (
          <li key={instruction} className={instructionsStyle[variant]}>
            {instruction}
          </li>
        ))}
      </Flex>
    </Flex>
  );
};
